import { ComponentProps } from 'react';

import mergeIntoFormData from '../../../../helpers/forms/mergeIntoFormData';
import filterObjectProperties from '../../../../helpers/objects/filterObjectProperties';
import AppliedCouponCode from '../../../../types/AppliedCouponCode';
import ErrorList from '../../../../types/UI/ErrorList';
import ValidationErrors from '../../../../types/UI/ValidationErrors';
import JsonForm from '../../../Form/JsonForm';
import CouponCodeFormFields from '../CouponCodeFormFields/CouponCodeFormFields';

type ValidateCouponDialogProps = {
    url: string;
    parameters: Record<string, any>;
    onSuccess?: (code: string | undefined) => void;
    onError?: (errors: ErrorList) => void;
} & ComponentProps<typeof CouponCodeFormFields>;

const ValidateCouponDialog = ({
    url,
    parameters,
    onSuccess,
    onError,
    ...fieldsProps
}: ValidateCouponDialogProps) => {
    const handleError = (errors: ValidationErrors) => {
        if (!onError) {
            return;
        }

        onError(errors.couponCode ?? ['An unknown error occurred.']);
    };

    const { dock, boatModel, couponCode, ...relevantParameters } =
        filterObjectProperties(
            parameters,
            (key, value) => value !== null && value !== undefined
        );

    return (
        <JsonForm<AppliedCouponCode>
            action={url}
            method="post"
            onBeforeSubmit={(data) => {
                mergeIntoFormData(data, relevantParameters);
            }}
            onSuccess={(data) => onSuccess && onSuccess(data.code)}
            onError={(response) => handleError(response?.errors ?? {})}
        >
            <CouponCodeFormFields {...fieldsProps} />
        </JsonForm>
    );
};

export default ValidateCouponDialog;
